export enum ProgressBarTypes {
    PAGE_TRANSITION = 1,
    PAGE_POSTING = 2,
    PAGE_UPDATING = 3,
    NOTHING = 0
}